var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 59.999,
    viewBox: "0 0 119 59.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1051 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.5,1641a59.222,59.222,0,0,1-33.267-10.162,59.673,59.673,0,0,1-21.557-26.178A59.127,59.127,0,0,1,79,1581.5c0-.167,0-.333,0-.5H198v.168c0,.11,0,.221,0,.332a59.223,59.223,0,0,1-10.162,33.267,59.674,59.674,0,0,1-26.178,21.557A59.126,59.126,0,0,1,138.5,1641Z",
    transform: "translate(972 -1581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,293.1V322.78H1.555L8.529,314.1h14.93l4.213-1.76,3.792-7.509-10.521-6.2-.971-3.711-7.129-3.1-4.313-7.256Z",
    transform: "translate(1097 -277.058)",
    fill: "#e52431"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormIcon);
export default __webpack_public_path__ + "static/media/form-icon.a0c4f2a5cc7add687816ec75d3bc58e5.svg";
export { ForwardRef as ReactComponent };